// extracted by mini-css-extract-plugin
export var container = "_lc-0";
export var segment = "_lc-2";
export var segmentActive = "_lc-3";
export var track = "_lc-1";